/**
 * Root Reducer
 * Combines all feature slices and RTK Query API reducer
 */

import { combineReducers } from '@reduxjs/toolkit';
import { baseApi } from '@/services/api';

// Feature slices will be imported here
// import usersReducer from '@/features/users/users.slice';
// import notificationsReducer from '@/features/notifications/notifications.slice';

/**
 * Combine all reducers
 */
export const rootReducer = combineReducers({
  // RTK Query API reducer
  [baseApi.reducerPath]: baseApi.reducer,

  // Add reducers here as features are implemented
  // users: usersReducer,
  // notifications: notificationsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
